import "./App.scss";
import React, { useEffect, useState } from "react";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";

import AppRouter from "./Routes/AppRouter";
import PortalPoliciesModal from "./Components/PortalPolicies";

const App = () => {
  const authRequest = { ...loginRequest };
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const hasAgreed = localStorage.getItem("portalPolicies");
    if (!hasAgreed) {
      setShowModal(true);
    }
  }, []);

  const handleAgree = () => {
    localStorage.setItem("portalPolicies", "true");
    setShowModal(false);
  };

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
    >
      <PortalPoliciesModal showModal={showModal} handleAgree={handleAgree} />
      <AppRouter />
    </MsalAuthenticationTemplate>
  );
};

export default App;
